import { Alert, Box, Button, Card, Snackbar, TextField, Typography } from '@mui/material';
import axios from 'axios';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { setAuthToken } from './Hooks/setAuthToken';
import history from './Routes/history';
import { BeforeInstallPromptEvent, LoginResponse } from './Types/Types';
import { buamatogVerificationKey } from './Types/Utility';

interface Props {

}

class Register extends Component<{}, { errors: { username: boolean, password: boolean, password_repeat: boolean }, errorTexts: {[key: string]: string}, errorMsg: string}> {
    constructor(props : Props) {
        super(props);
        
        this.state={
            errors: {
                username: false,
                password: false,
                password_repeat: false,
            },
            errorTexts: {},
            errorMsg: ""
        }
    }

    componentDidMount() {
        let isTooSoon = true;
        window.addEventListener("beforeinstallprompt", (e : BeforeInstallPromptEvent ) => {
            if (isTooSoon) {
                e.preventDefault(); // Prevents prompt display
                // Prompt later instead:
                setTimeout(() => {
                    isTooSoon = false;
                    e.prompt(); // Throws if called more than once or default not prevented
                }, 10000);
            }

            // The event was re-dispatched in response to our request
            // …
        });

        const buamatogkey = buamatogVerificationKey();
        const token = localStorage.getItem(buamatogkey);
        const overwrite = localStorage.getItem('buamatog-is-wonn-i-sog-2025');
        localStorage.clear();
        if (token) {
            localStorage.setItem(buamatogkey, token);
            if (overwrite) {
                localStorage.setItem('buamatog-is-wonn-i-sog-2025', overwrite);
            }
        }
    }
    
    
    hasErrors = (name?:string) => {
        const { errors } = this.state;

        if (name) {
            switch (name) {
                case 'username':
                    return errors.username;
                case 'password':
                    return errors.password;
                case 'password_repeat':
                    return errors.password_repeat;    
            }
        }
        return errors.username || errors.password || errors.password_repeat;
    }

    check = (username : string, password : string, password_repeat: string) => {
        const _self = this;
        return new Promise((resolve, reject) => {
            let hasErrors = false;
            let errors = {
                username: false,
                password: false,
                password_repeat: false,
            };
            let errorTexts : {[key:string] : string} = {};
            if (username.length < 4) {
                errors.username = true;
                hasErrors = true;
                errorTexts['username'] = 'Nome z`kuschz';
            }

            if (password.length < 8) {
                errors.password = true;
                hasErrors = true;
                errorTexts['password'] = 'Password z`kuschz';
            }

            if (password_repeat.length < 8) {
                errors.password_repeat = true;
                hasErrors = true;
                errorTexts['password'] = 'Password z`kuschz';
            }

            if (password_repeat !== password) {
                errors.password = true;
                errors.password_repeat = true;
                hasErrors = true;
                errorTexts['password'] = 'Passweaschta sen nit gleich du Vogl.';
            }
            _self.setState({
                errors: errors,
                errorTexts: errorTexts,
            })
            if (hasErrors) {
                reject(false);
                return false;
            }
            resolve(true);
            return true;
        });
    }

    handleSubmit = (e : React.SyntheticEvent) => {
        e.preventDefault();
        const target = e.target as typeof e.target & {
            username: { value: string };
            password: { value: string };
            password_repeat: { value: string };
        };
        const username = target.username.value;
        const password = target.password.value;
        const password_repeat = target.password_repeat.value;
        
        
        const _self = this;
        _self.check(username, password, password_repeat)
            .then(res => {
                if (!_self.hasErrors()) {
                    axios.post<LoginResponse>('/register', {
                            username: username,
                            password: password,
                            password_repeat: password_repeat,
                        })
                        .then(res => {
                            setAuthToken(res.data.token);
                            history.push('/');
                        })
                        .catch(err => {
                            const errors = err.response.data.errors;
                            this.setState({
                                errors: {
                                    username: true,
                                    password: true,
                                    password_repeat: true,
                                },
                                errorTexts: errors,
                                errorMsg: 'Account erstellen fehlgeschlagen',
                            });
                            setAuthToken(null);
                        });
                }
            }).catch(err => {
                this.setState({
                    errors: {
                        username: true,
                        password: true,
                        password_repeat: true,
                    },
                    errorMsg: 'Account erstellen fehlgeschlagen',
                });
                setAuthToken(null);
            });

        return false;
    }

    handleCloseError = () => {
        this.setState({
            errorMsg: "",
        });
    }

    getErrorText = (name : string) => {
        const { errorTexts } = this.state;
        if (this.hasErrors(name)) {
            if (typeof errorTexts[name] !== 'undefined' && errorTexts[name] !== '') {
                return errorTexts[name];
            }
        }
        return undefined;
    }

    render() {
        const { errorMsg } = this.state;


        const inputProps = {
            fullWidth: true,
            sx: { display: 'block', m: 1, width: 'calc(100% - 20px)' }
        };

        return (
            <React.Fragment>
                <Snackbar open={errorMsg !== ""} autoHideDuration={6000} onClose={() => this.handleCloseError()} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                    <Alert onClose={() => this.handleCloseError()} severity="error" sx={{ width: '100%' }}>
                        {errorMsg}
                    </Alert>
                </Snackbar>
                <Box 
                    flexGrow={1} 
                    sx={{ 
                        overflowY: 'auto',
                        position: 'relative',
                        minHeight: '100vh',
                        background: 'linear-gradient(135deg, #181818 0%, #232323 50%, #E2B13C 100%)',
                    }}
                >
                    {/* Wave Background */}
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            overflow: 'hidden',
                            lineHeight: 0,
                            transform: 'rotate(180deg)',
                            zIndex: 0,
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1200 120"
                            preserveAspectRatio="none"
                            style={{ width: '100%', height: '150px' }}
                        >
                            <path
                                d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
                                style={{ fill: '#ffffff', opacity: 0.3 }}
                            />
                            <path
                                d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
                                style={{ fill: '#ffffff', opacity: 0.5 }}
                            />
                        </svg>
                    </Box>

                    {/* Content */}
                    <Box sx={{ position: 'relative', zIndex: 1, height: '100%', display: 'grid', placeItems: 'center', textAlign: 'center', py: 4 }}>
                        <Card 
                            sx={{ 
                                background: 'rgba(35, 35, 35, 0.8)',
                                backdropFilter: 'blur(12px)',
                                boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.5)',
                                borderRadius: '16px',
                                border: '1px solid rgba(255, 215, 0, 0.18)',
                                maxWidth: '500px',
                                width: '90%',
                                p: 3,
                            }}
                        >
                            <Box component={"form"} noValidate autoComplete={"off"} onSubmit={this.handleSubmit} sx={{ width: '100%' }}>
                                <Box sx={{ p: 2 }}>
                                    <img 
                                        src={process.env.PUBLIC_URL + '/LogoBuamatog_nobg_224x204.png'} 
                                        alt="Buamatog Logo"
                                        style={{ maxHeight: '25vh', maxWidth: '100%' }}
                                    />
                                </Box>
                                <Box sx={{ p: 2 }}>
                                    <Typography variant={'h4'} sx={{ fontWeight: 600, color: '#FFFFFF' }}>Buamatog Registrierung</Typography>
                                    <Typography variant={'body1'} sx={{ color: '#CCCCCC', mt: 1 }}>Passwort mindestens 8 Zoachn</Typography>
                                    <Typography variant={'body1'} sx={{ color: '#CCCCCC' }}>Des zeug vom letztn johr geht nimma!</Typography>
                                </Box>
                                <Box>
                                    <TextField id="username" name="username" error={this.hasErrors("username")} helperText={this.getErrorText("username")} label="Username" variant="outlined" required={true} {...inputProps}/>
                                    <TextField id="password" type="password" name="password" error={this.hasErrors("password")} helperText={this.getErrorText("password")} label="Passwort" variant="outlined" required={true} {...inputProps}/>
                                    <TextField id="password-repeat" type="password" name="password_repeat" error={this.hasErrors("password_repeat")} helperText={this.getErrorText("password")} label="Passwort wiederholen" variant="outlined" required={true} {...inputProps}/>
                                </Box>
                                <Box sx={{ display: 'grid', placeItems: 'center', width: '100%', textAlign: 'center', mt: 2 }}>
                                    <Button type={"submit"} variant="contained" size="large" sx={{ minWidth: '200px' }}>
                                        Registrieren
                                    </Button>
                                </Box>
                                <Box sx={{ display: 'grid', placeItems: 'center', width: '100%', textAlign: 'center', mt: 1 }}>
                                    <Button component={Link} to={"/login"}>Login</Button>
                                </Box>
                            </Box>
                        </Card>
                    </Box>
                </Box>
            </React.Fragment>
        );
    }
}
export default Register;